// extracted by mini-css-extract-plugin
export default {"root":"LockedThumbnail_root__iluQe","thumbnail":"LockedThumbnail_thumbnail__xxQyP"};